module.exports = __webpack_public_path__ + "01ea978f/img/trash-icon.ff8201c7.svg";